module.exports = __webpack_public_path__ + "static/media/Component 28 – 1.1a76cd74.svg";